import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=2065d317&scoped=true&"
import script from "./DomainList.vue?vue&type=script&lang=js&"
export * from "./DomainList.vue?vue&type=script&lang=js&"
import style0 from "./DomainList.vue?vue&type=style&index=0&id=2065d317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065d317",
  null
  
)

export default component.exports